export const CYCLE_TYPE = {
    DRS: "DRS"
}
